var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { selectAppContent, selectEventId, selectSelfApp } from "@adm-media/adam-store-plugin";
import { useSelector } from "react-redux";
import Button from "../Button";
import { AgendaIcon } from "../../Icons/Icons";
import { useState } from "react";
import { saveAs } from "file-saver";
import { useNotification } from "../../../../hooks/useNotification";
import "./DownloadICSButton.scss";
import classNames from "classnames";
export var DownloadICSButton = function (_a) {
    var _b, _c;
    var block = _a.block, className = _a.className, hideLabelOnMobile = _a.hideLabelOnMobile;
    var locale = useSelector(selectSelfApp).locale;
    var contents = useSelector(selectAppContent);
    var eventId = useSelector(selectEventId);
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var notification = useNotification().notification;
    var baseClass = "download-ics-button";
    var downloadFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var langParam, response, blob, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    langParam = locale ? "?lang_id=".concat(locale) : "";
                    return [4 /*yield*/, fetch("".concat(process.env.BASE_URL, "/v2/event/").concat(eventId, "/save-date").concat(langParam), {
                            method: "GET",
                            credentials: "same-origin"
                        })];
                case 2:
                    response = _b.sent();
                    if (!response.ok)
                        throw new Error(response.statusText);
                    return [4 /*yield*/, response.blob()];
                case 3:
                    blob = _b.sent();
                    saveAs(blob, (contents === null || contents === void 0 ? void 0 : contents.save_the_date_filename) || (contents === null || contents === void 0 ? void 0 : contents.event_title) || "event");
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    notification.showGenericError();
                    return [3 /*break*/, 6];
                case 5:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Button, __assign({ "data-testid": "download-ics-button", onClick: function () { return downloadFile(); }, icon: _jsx(AgendaIcon, {}), block: block, loading: isLoading, className: classNames(baseClass, (_b = {}, _b["".concat(className)] = !!className, _b), (_c = {}, _c["".concat(baseClass, "--hide-label-on-mobile")] = hideLabelOnMobile, _c)) }, { children: _jsx("span", __assign({ className: "".concat(baseClass, "__label") }, { children: (contents === null || contents === void 0 ? void 0 : contents.save_the_date_button_text) || "Save the date" })) })));
};
